export default function readIsManaVersionFlag() {
    const isMANAVersion = localStorage.getItem('isMANAVersion');

    if (!isMANAVersion) {
        return false;
    }

    return isMANAVersion.toLowerCase() === 'true';
}